import React from 'react';
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import ImageHero from 'app/theme/ImageHero'
import hero from 'assets/img/campus-catering.jpg'
import Calculator from 'app/theme/calculator'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import CateringOccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import campusCatering1 from 'assets/img/campus-food-truck-catering-2.jpeg'
import campusCatering2 from 'assets/img/campus-catering-with-food-trucks-3.jpeg'
import campusCatering3 from 'assets/img/campus-food-truck-catering-4.jpeg'
import campusCatering4 from 'assets/img/food-truck-campus-events.jpg'
import getGoogleMetaTags from './occasionSEOData'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import { useInView } from 'react-intersection-observer'

export default function CampusCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  const googleMetaTags = getGoogleMetaTags('campus')

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>On-Campus Food Truck Catering - Roaming Hunger</title>
        <meta name="description" content="Food trucks are a great university or campus catering option. Roaming Hunger can help coordinate food trucks to cater any university or school event across the country."></meta>
        <meta name="og:title" content="On-Campus Food Truck Catering"></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={hero}
          title="Food Trucks on Campus"
          onButtonClick={openModal}
          description={(
            <span>
              Looking to feed your entire student body? Want to give your faculty a festive dining option? Bring food trucks to your next school or university event.
            </span>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <IntroGrid />
      <FeaturedClients onButtonClick={openModal} />
      <FeaturedClientsGrid />
      <WhyWorkWithUs onButtonClick={openModal} className="-mt-10" />
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorks heading="How Food Truck Catering for Schools Works" onButtonClick={openModal} />
      <HowItWorksLarge heading="How Food Truck Catering for Schools Works" onButtonClick={openModal} />
      <Calculator onButtonClick={openModal} />
      <CateringOccasionsSlider
        className="bg-white py-12"
      />
    </Layout>
  )
}

function IntroGrid() {
  return (
    <OccasionPageGrid className="py-10">
      <OccasionPageGridRow
        heading="Food For All Ages"
        content="From ice cream for grade schoolers to kobe beef sliders for fancy alumni, we’ve got food trucks and mobile chefs for every palate and occasion.  When you work with us, we’ll find the perfect fit for your school’s needs. - with thousands of vendors in our national database, we can ace any assignment."
        image={campusCatering1}
        reverse
      />
      <OccasionPageGridRow
        heading="A Flexible Solution"
        content="From outdoor school carnivals to cafeterias under renovation, we bring food trucks and pop ups to where traditional catering cannot go (and leave no mess behind). We can even bring tables, chairs, linens - anything you need to complete the scene."
        image={campusCatering2}
      />
    </OccasionPageGrid>
  )
}

function FeaturedClientsGrid() {
  return (
    <OccasionPageGrid className="py-10">
      <OccasionPageGridRow
        heading="Your School's Better With Great Food"
        content="Whether you’re honoring the graduating class, or welcoming new students to campus, we offer a network of over 23,000 creative, excitement-building food trucks and mobile chefs that make big moments on campus feel that much bigger. Make your school’s food as compelling as your subjects - and get perfect attendance at every table."
        image={campusCatering3}
        reverse
      />
      <OccasionPageGridRow
        heading="We've Got You Covered"
        content="Book your on-campus event with confidence knowing we have established relationships with the food trucks. We will start by providing the tastiest options and secure the best food trucks for your budget. The funds are held until after your event, so we can guarantee you will get fantastic service every time."
        image={campusCatering4}
      />
    </OccasionPageGrid>
  )
}
